"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    carouselBlurBoxVariants: ()=>carouselBlurBoxVariants,
    CarouselBlurBoxIncludedOptions: ()=>CarouselBlurBoxIncludedOptions
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const CarouselBlurBoxIncludedOptions = [
    'numbers',
    'lightbox',
    'autoplay'
];
const carouselBlurBoxVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        blurBoxSlot: 'bg-neutral-12/40 pointer-events-auto absolute bottom-2 right-2 flex items-center rounded-md backdrop-blur',
        blurBoxNumbersSlot: 'pointer-events-none flex min-h-7 items-center justify-center rounded-md',
        blurBoxLightboxButtonSlot: 'flex h-8 w-8 items-center justify-center rounded-md',
        blurBoxAutoplayButtonSlot: 'flex h-8 w-8 items-center justify-center rounded-md',
        blurBoxDividerSlot: 'bg-neutral-1/20 h-4 w-px'
    },
    variants: {
        numbers: {
            true: {
                blurBoxNumbersSlot: 'pointer-events-none flex min-h-7 items-center justify-center rounded-md px-2'
            },
            false: {}
        },
        numbersAndLightbox: {
            true: {
                blurBoxNumbersSlot: 'pointer-events-none flex min-h-7 items-center justify-center rounded-md pl-2'
            }
        },
        numbersAndAutoplay: {
            true: {
                blurBoxNumbersSlot: 'pointer-events-none flex min-h-7 items-center justify-center rounded-md px-2'
            }
        },
        numbersAndLightboxAndAutoplay: {
            true: {
                blurBoxNumbersSlot: 'pointer-events-none flex min-h-7 items-center justify-center rounded-md pl-2'
            }
        }
    },
    defaultVariants: {
        numbers: false
    }
});
exports.CarouselBlurBoxIncludedOptions = __webpack_exports__.CarouselBlurBoxIncludedOptions;
exports.carouselBlurBoxVariants = __webpack_exports__.carouselBlurBoxVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CarouselBlurBoxIncludedOptions",
    "carouselBlurBoxVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
